// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"8ec3ab50","453":"aedfa237"}[chunkId] + ".chunk.js";
};